import { Response } from "react-select-async-paginate";
import AsyncPaginateBootstrap from "../react-select-bootstrap/AsyncPaginateBootstrap";
import { getList } from "../../api/generics";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import Store from "../../models/store";

const RECORS_PER_SEARCH = 20;

type StoresSelectProps = {
  value: readonly Store[];
  onChange: React.Dispatch<React.SetStateAction<readonly Store[]>>;
  isDisabled?: boolean;
};

const StoresSelect: React.FC<StoresSelectProps> = ({
  value,
  onChange,
  isDisabled,
}) => {
  const companyId = useSelector(
    (state: RootState) => state.company.data.company.id
  );
  const loadOptions = async (
    s: string,
    currentOpts: readonly (Store | { options: Store[]; label?: string })[]
  ): Promise<Response<Store, { options: Store[]; label?: string }, any>> => {
    let additionalParams: Map<string, string> | undefined = new Map<
      string,
      string
    >();

    additionalParams.set("company_id", companyId!.toString());

    if (s !== "") {
      additionalParams.set("search", s);
    }

    const dataPaginated = await getList<Store>(
      "/stores/",
      RECORS_PER_SEARCH,
      currentOpts.length,
      additionalParams
    );

    let newOpts: Store[] = [];
    let count = 0;

    if (dataPaginated.data !== undefined) {
      newOpts = dataPaginated.data.items;
      count = dataPaginated.data.count;
    }

    const hasMore = currentOpts.length + newOpts.length < count;

    return {
      options: newOpts,
      hasMore: hasMore,
    };
  };
  return (
    <AsyncPaginateBootstrap
      placeholder="Selecciona las tiendas para este descuento"
      onChange={onChange}
      isMulti={true}
      debounceTimeout={300}
      loadOptions={loadOptions}
      getOptionLabel={(option: Store) => `${option.name}`}
      getOptionValue={(option: Store) => `${option.id}`}
      value={value}
      isDisabled={isDisabled}
    />
  );
};

export default StoresSelect;
